module.exports = __webpack_public_path__ + "img/face-relieved.a214b1f7.svg";